/**
 * Apaga no boot a credencial deixada pela versão anterior (JIMEA-954).
 *
 * Parar de escrever não limpa o que já estava lá: para quem já usou a versão antiga, o
 * token segue no localStorage, legível por JavaScript e válido na API até vencer.
 */

const CHAVES_LEGADAS = ['user-token', 'user-trusted-2fa']

/** Chave onde o pinia-plugin-persistedstate serializa o store de autenticação. */
const CHAVE_STORE_AUTH = 'auth'

export function purgeLegacyCredentials(storage = window.localStorage) {
  try {
    CHAVES_LEGADAS.forEach((chave) => storage.removeItem(chave))

    // O blob antigo fica no disco até a próxima escrita, e o plugin o reidrata antes
    // disso — trazendo o token de volta para a memória.
    const bruto = storage.getItem(CHAVE_STORE_AUTH)

    if (!bruto) return

    const estado = JSON.parse(bruto)

    if (estado && typeof estado === 'object' && 'token' in estado) {
      delete estado.token
      storage.setItem(CHAVE_STORE_AUTH, JSON.stringify(estado))
    }
  } catch (erro) {
    // Storage indisponível ou blob corrompido não pode impedir o boot.
    console.warn('[auth] não foi possível limpar credenciais legadas do storage', erro)
  }
}
